import { render, staticRenderFns } from "./batchAliasEdit.vue?vue&type=template&id=3516fc9c&scoped=true&lang=html&"
import script from "./batchAliasEdit.vue?vue&type=script&lang=js&"
export * from "./batchAliasEdit.vue?vue&type=script&lang=js&"
import style0 from "./batchAliasEdit.vue?vue&type=style&index=0&id=3516fc9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516fc9c",
  null
  
)

export default component.exports